import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TitleService } from "src/app/title.service";
import { Account, AccountDTO } from "../Account";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { StatesService } from "src/app/shared/states/states.service";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { AccountService } from "../account.service";
import { NotificationService } from "src/app/notifications/notification.service";
import { SessionService } from "src/app/session.service";
import { UserDTO } from "src/app/auth/User";
import { UsersService } from "src/app/user/users.service";
import { AccountUserDTO } from "../AccountUser";
import { forkJoin, Subject } from "rxjs";
import { FacilityDTO } from "src/app/facilities/Facility";
import { RoleDTO } from "../../roles/Role";
import { PermissionService } from "src/app/permission.service";
import { UiService } from "src/app/ui/ui.service";
import { switchMap, takeUntil, tap } from "rxjs/operators";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { SignalsService } from "src/app/signals/signals.service";
import { find, remove } from "lodash";
import { LocalStorageService } from "src/app/storage/local-storage.service";

//TODO-PERMISSIONS: Handle user adding for super users

@Component({
  selector: "app-account",
  templateUrl: "./account.component.html",
  styleUrls: ["./account.component.scss"],
})
export class AccountComponent implements OnInit {
  perPage: number = 20;
  pageSizeOptions = pageSizeOptions;
  displayedCategoryColumns = ["name", "icon", "color", "preview", "options"];
  searchValue: string = "";
  newAccount!: boolean;
  account?: AccountDTO;
  accountForm!: FormGroup;
  businessCategoryOptions = [
    { code: "attraction", name: "Attraction" },
    { code: "casinoOrGaming", name: "Casino/Gaming" },
    { code: "hotelOrLodging", name: "Hotel/Lodging" },
    { code: "restaurant", name: "Restaurant" },
    { code: "retail", name: "Retail" },
    { code: "spaOrSalon", name: "Spa/Salon/Other Retail Personal Service" },
    { code: "travel", name: "Travel/Tourism Destination" },
    { code: "other", name: "Other" },
  ];
  statesOptions: any;
  unassignedUsers!: UnassignedUser[];
  roles!: RoleDTO[];
  groups!: any[];
  facilities!: FacilityDTO[];
  selectedFacilities!: any[];
  accountUserForm!: FormGroup;
  selectedGroupsObjArr!: any[];
  accountUserFormChanged: boolean = false;
  disableTeamMemberRemove: boolean = true;
  showUnassignedPersonnel: boolean | undefined;
  filteredUsers: any;
  private onComponentDestroy = new Subject();
  accountSignalCategories: any;
  categoriesDataSource!: MatTableDataSource<unknown>;
  @ViewChild("categoriesTable") categoriesTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  hasCategoriesList: boolean = false;
  hasCategoriesWrite: boolean = false;
  hasCategoriesDelete: boolean = false;
  features: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private TitleService: TitleService,
    private StatesService: StatesService,
    private dialog: MatDialog,
    private AccountService: AccountService,
    private NotificationService: NotificationService,
    private SessionService: SessionService,
    private router: Router,
    private UserService: UsersService,
    private PermissionService: PermissionService,
    private uiService: UiService,
    private signalService: SignalsService,
    private route: ActivatedRoute,
    private localStorageSvc: LocalStorageService
  ) {
    this.statesOptions = this.StatesService.states;
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue!;
  }

  get accountDTO() {
    let accountDTO = {
      name: this.accountForm.controls.companyName.value,
      address1: this.accountForm.controls.companyAddress.value,
      address2: this.accountForm.controls.suiteUnitEtc.value,
      city: this.accountForm.controls.city.value,
      state_province: this.accountForm.controls.state.value,
      postal_code: this.accountForm.controls.zip.value,
      first_name: this.accountForm.controls.firstName.value,
      last_name: this.accountForm.controls.lastName.value,
      email: this.accountForm.controls.email.value,
      phone: this.accountForm.controls.phone.value,
      business_category: this.accountForm.controls.businessCategory.value,
      service_level: this.accountForm.controls.serviceLevel.value,
      catalog: this.account?.catalog ?? {},
      stripeCustomers: this.account?.stripeCustomers.map((cust)=>{
        return {
          id: cust.id,
          stripe_id: this.accountForm.controls[cust.id+'_stripe_id'].value,
          stripe_name: this.accountForm.controls[cust.id+'_stripe_name'].value
        }
      }),
      features: this.features
        .filter((feature: any) => feature.selected)
        .map((feature: any) => {
          return { feature_id: feature.id, account_id: this.account?.id };
        }),
    };

    if (this.account) {
      accountDTO = { ...this.account, ...accountDTO };
    }

    return accountDTO;
  }

  get hasAccountUserChanged() {
    return this.accountUserFormChanged || this.selectedFacilities !== [];
  }

  get currentUser() {
    return this.SessionService.currentUserValue;
  }

  ngOnInit(): void {
    this.perPage = this.localStorageSvc.pageSize || 20;
    this.account = this.activatedRoute.snapshot.data.account;
    this.features = this.activatedRoute.snapshot.data.features.map((feature: any) => {
      return {
        id: feature.id,
        name: feature.name,
        key: feature.key,
        selected: find(this.account?.features, { feature_id: feature.id }) !== undefined,
      };
    });
    this.unassignedUsers =
      this.activatedRoute.snapshot.data.unassignedUsers.records.map(
        (user: UserDTO) => new UnassignedUser(user),
      );

    this.filteredUsers = [];
    //TODO: Have API filter roles based on account
    if (this.account) {
      this.roles = this.activatedRoute.snapshot.data.roles.filter(
        (role: any) => !role.account_id || role.account_id === this.account!.id,
      );
      this.groups = this.activatedRoute.snapshot.data.groups;
      this.facilities = this.activatedRoute.snapshot.data.facilities.records;
    }
    this.newAccount = !this.account;
    if (!this.newAccount) {
      this.TitleService.setTitle(
        this.TitleService.getTitle() + ` | ${this.account?.name}`,
      );
    }

    this.initiateForms();

    this.showUnassignedPersonnel = this.SessionService.currentUserValue?.super;

    Promise.all([
      this.PermissionService.categories.accountUsers.hasWrite(),
      this.PermissionService.categories.accountSignalCategories.hasList(),
      this.PermissionService.categories.accountSignalCategories.hasWrite(),
      this.PermissionService.categories.accountSignalCategories.hasDelete(),
    ]).then(
      ([
        accountUsersHasWrite,
        accountSignalCategoriesList,
        accountSignalCategoriesWrite,
        accountSignalCategoriesDelete,
      ]) => {
        this.disableTeamMemberRemove = !accountUsersHasWrite;
        this.hasCategoriesList = accountSignalCategoriesList;
        this.hasCategoriesWrite = accountSignalCategoriesWrite;
        this.hasCategoriesDelete = accountSignalCategoriesDelete;

        setTimeout(() => {
          this.initSignalCategories(
            this.activatedRoute.snapshot.data.accountSignalCategories,
          );
        });
      },
    );
  }

  ngAfterViewInit() {
    this.categoriesTable?.renderRows();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  initiateForms() {

    let formGroup: any = {
      companyName: new FormControl(this.account?.name, [Validators.required]),
      companyAddress: new FormControl(
        this.account?.address1,
        Validators.required,
      ),
      suiteUnitEtc: new FormControl(this.account?.address2),
      city: new FormControl(this.account?.city, Validators.required),
      state: new FormControl(this.account?.state_province, Validators.required),
      zip: new FormControl(this.account?.postal_code, Validators.required),
      firstName: new FormControl(this.account?.first_name, Validators.required),
      lastName: new FormControl(this.account?.last_name, Validators.required),
      email: new FormControl(this.account?.email, [
        Validators.required,
        Validators.email,
      ]),
      phone: new FormControl(this.account?.phone, Validators.required),
      businessCategory: new FormControl(
        this.account?.business_category,
        Validators.required,
      ),
      serviceLevel: new FormControl("observe", [Validators.required]),
    };

    this.account?.stripeCustomers.forEach((cust)=>{
      formGroup[cust.id+'_stripe_name'] = new FormControl(cust.stripe_name, Validators.required);
      formGroup[cust.id+'_stripe_id'] = new FormControl(cust.stripe_id, Validators.required);
    })

    formGroup['new_stripe_name'] = new FormControl('');
    formGroup['new_stripe_id'] = new FormControl('');

    this.accountForm = new FormGroup(formGroup);

  }

  initAccountUserForm() {
    this.selectedFacilities = [];
    this.accountUserForm = new FormGroup({
      role: new FormControl("", [Validators.required]),
      groups: new FormControl([]),
      showFacilitiesRestriction: new FormControl(false),
    });
    this.selectedGroupsObjArr = [];
    this.accountUserForm.controls.groups.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((change) => {
        this.selectedGroupsObjArr = change?.map((selectedGroup: number) => {
          return this.groups.find((group: any) => group.id === selectedGroup);
        });
      });

    this.accountUserForm.controls.showFacilitiesRestriction.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((change) => {
        if (change) {
          this.selectedFacilities = [];
        }
      });

    //If value changes on any control, give user warning before the try closing the account user without saving
    this.accountUserForm.valueChanges
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((change) => {
        this.accountUserFormChanged = true;
      });
  }

  initSignalCategories(categories: any[]) {
    this.accountSignalCategories = categories;

    this.accountSignalCategories.forEach((category: any) => {
      const oldIconMap = this.uiService.oldFAIconsMap.find(
        (icon) => icon.name === category.icon,
      );
      //Some icons are old Fontawesome icons, this is used to update them
      if (oldIconMap) {
        category.icon = oldIconMap.newIconString;
      }
      category.iconArr = category.icon!.split(" ");
    });

    this.categoriesDataSource = new MatTableDataSource(
      this.accountSignalCategories,
    );

    this.categoriesDataSource.sort = this.sort;
    this.categoriesDataSource.paginator = this.paginator;
  }

  onShowRestrictionsClicked() {
    if (this.accountUserForm.controls.showFacilitiesRestriction.enabled) {
      this.accountUserForm.controls.showFacilitiesRestriction.setValue(
        !this.accountUserForm.controls.showFacilitiesRestriction.value,
      );
    }
  }

  onFacilityToggled(facility: FacilityDTO) {
    if (!!this.selectedFacilities?.includes(facility.id)) {
      this.selectedFacilities = this.selectedFacilities.filter((facilityID) => {
        return facilityID !== facility.id;
      });
    } else {
      this.selectedFacilities?.push(facility.id);
    }
  }

  get openedUser() {
    return this.unassignedUsers?.find((account) => {
      return account.expanded;
    });
  }

  get saveDisabled() {
    return (
      this.accountForm.invalid ||
      (!!this.openedUser && this.hasAccountUserChanged)
    );
  }

  get catalogDisabled() {
    return false;
  }

  get hasSearchValue() {
    return !!this.searchValue && this.searchValue !== "";
  }

  get hasResults() {
    return !!this.filteredUsers?.length;
  }

  saveNewStripeCustomer() {

    this.uiService
      .waitForEvent(
        this.AccountService.createStripeCustomer(
          this.account?.id!,
          this.accountForm?.controls['new_stripe_id'].value,
          this.accountForm?.controls['new_stripe_name'].value
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        (result: any) => {
          this.account?.stripeCustomers.push(result);
          this.initiateForms();
          this.accountForm?.controls['new_stripe_id'].setValue('');
          this.accountForm?.controls['new_stripe_name'].setValue('');
        });

    
  }

  deleteStripeCustomer(customer: any) {

    this.uiService
      .waitForEvent(
        this.AccountService.deleteStripeCustomer(
          customer
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        (result) => {
          remove(this.account?.stripeCustomers!, {
            id: customer.id
          })
        });

  }

  get newStripeCustomerDisabled() {
    if(this.accountForm?.controls['new_stripe_name'].value == ''){
      return true;
    }
    if(this.accountForm?.controls['new_stripe_id'].value == ''){
      return true;
    }
    return false;
  }

  closeAccountUser() {
    if (this.hasAccountUserChanged) {
      this.dialog
        .open(AreYouSureDialogComponent, {
          data: {
            areYouSureInfo: {
              description: "You will lose any unsaved account information",
            },
          },
        })
        .afterClosed()
        .pipe(takeUntil(this.onComponentDestroy))
        .subscribe((result) => {
          if (result) {
            this.openedUser!.expanded = false;
            this.accountUserFormChanged = false;
          }
        });
    } else {
      this.openedUser!.expanded = false;
      this.accountUserFormChanged = false;
    }
  }

  changeServiceLevelValue(value: string) {
    this.accountForm.controls.serviceLevel.setValue(value);
  }

  cancel() {
    this.router.navigate(["accounts", "list"]);
  }

  saveNewAccount() {
    this.uiService
      .waitForEvent(
        this.AccountService.createAccount(
          this.currentAccount.accountID,
          this.accountDTO as AccountDTO,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        (account: Account) => {
          this.uiService
            .waitForEvent(
              this.UserService.getUser(
                this.currentAccount!.accountID,
                this.currentUser!.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              (user) => {
                this.SessionService.updateAccounts(user as unknown as UserDTO);
                this.SessionService.availableAccounts?.forEach((availAccount) => {
                  if (availAccount.accountID === account.id) {
                    this.SessionService.setCurrentAccount(availAccount);
                  }
                });
                // Prompt for guided setup on successful account creation
                this.dialog
                  .open(AreYouSureDialogComponent, {
                    data: {
                      areYouSureInfo: {
                        title: "Run guided setup?",
                        description:
                          "Would you like to walk through key setup steps for this new account?",
                        continueBtn: {
                          text: "Yes, start guided setup",
                        },
                        cancelBtn: {
                          text: "No thanks",
                        },
                      },
                    },
                  })
                  .afterClosed()
                  .pipe(takeUntil(this.onComponentDestroy))
                  .subscribe((res) => {
                    if (res) {
                      this.localStorageSvc.setGuidedSetupEnabled(account.id, true);
                    }
                    this.router.navigate(["accounts", "list"]);
                  });
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error retrieving user",
                );
              },
            );

          this.NotificationService.openSuccessSnackBar(
            "Account created successfully",
          );
        },
        () => {
          this.NotificationService.openErrorSnackBar("Error creating account");
        },
      );
  }

  saveAccountUser(user: UnassignedUser) {
    const accountUserDTO = {
      account_id: this.account!.id,
      user_id: user.id,
      groups: this.accountUserForm.controls.groups.value,
      restrict_to_facilities: this.accountUserForm.controls
        .showFacilitiesRestriction.value
        ? this.selectedFacilities! ?? []
        : null,
      role_id: this.accountUserForm.controls.role.value,
    };

    this.uiService
      .waitForEvent(
        this.UserService.createAccountUser(
          accountUserDTO.account_id,
          accountUserDTO as AccountUserDTO,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        () => {
          this.NotificationService.openSuccessSnackBar("Account User created");
          const accountObs = this.AccountService.getAccount(
            this.currentAccount.accountID,
            this.account!.id,
          );
          const unassignedUsersObs = this.UserService.getUsers(
            this.currentAccount.accountID,
            {
              ignoreSuper: false,
              unassigned: true,
              page: 0,
              perPage: 999999999,
            },
          );

          this.uiService
            .waitForEvent(forkJoin([accountObs, unassignedUsersObs]))
            .pipe(takeUntil(this.onComponentDestroy))
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(([account, unassignedUsers]) => {
              this.account = account as unknown as AccountDTO;
              this.unassignedUsers = (
                unassignedUsers.records as unknown as UserDTO[]
              ).map((user: UserDTO) => new UnassignedUser(user));

              this.applyFilter();
            });
        },
        () => {
          this.NotificationService.openErrorSnackBar(
            "Error creating account user",
          );
        },
      );
  }

  onUserRemoved(user: UserDTO) {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this team member ( ${
              user.first_name && user.first_name
                ? user.first_name + " " + user.last_name
                : user.email
            } )?`,
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.uiService
            .waitForEvent(
              this.UserService.deleteAccountUser(
                this.currentAccount.accountID,
                user.accountUsers[0].id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar(
                  "Team member deleted successfully",
                );

                const accountObs = this.AccountService.getAccount(
                  this.currentAccount.accountID,
                  this.account!.id,
                );
                const unassignedUsersObs = this.UserService.getUsers(
                  this.currentAccount.accountID,
                  {
                    ignoreSuper: false,
                    unassigned: true,
                    page: 0,
                    perPage: 999999999,
                  },
                );

                this.uiService
                  .waitForEvent(forkJoin([accountObs, unassignedUsersObs]))
                  .pipe(takeUntil(this.onComponentDestroy))
                  .subscribe(([account, unassignedUsers]) => {
                    this.account = account as unknown as AccountDTO;
                    this.unassignedUsers = unassignedUsers.records.map(
                      (user: UserDTO) => new UnassignedUser(user),
                    );
                    this.applyFilter();
                  });
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting team member",
                );
              },
            );
        }
      });
  }

  addAccountUser(user: UnassignedUser) {
    this.account?.users.push(user);
    this.unassignedUsers = this.unassignedUsers.filter(
      (unassignedUser) => unassignedUser !== user,
    );

    this.applyFilter();
  }

  deleteAccount() {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this account ( ${
              this.account!.name
            } )?`,
            warning: "Warning: this is not reversible!",
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.uiService
            .waitForEvent(
              this.AccountService.deleteAccount(
                this.currentAccount.accountID,
                this.account!.id,
                true,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.uiService
                  .waitForEvent(
                    this.UserService.getUser(
                      this.currentAccount!.accountID,
                      this.currentUser!.id,
                    ),
                  )
                  .pipe(takeUntil(this.onComponentDestroy))
                  .subscribe(
                    (user) => {
                      this.SessionService.updateAccounts(
                        user as unknown as UserDTO,
                      );
                      this.router.navigate(["accounts", "list"]);
                    },
                    () => {
                      this.NotificationService.openErrorSnackBar(
                        "Error retrieving user",
                      );
                    },
                  );

                this.NotificationService.openSuccessSnackBar("Account deleted");
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting account",
                );
              },
            );
        }
      });
  }

  saveAccountUpdates() {
    this.uiService
      .waitForEvent(
        this.AccountService.updateAccount(
          this.currentAccount.accountID,
          this.accountDTO as AccountDTO,
          true,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        () => {
          this.uiService
            .waitForEvent(
              this.UserService.getUser(
                this.currentAccount!.accountID,
                this.currentUser!.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              (user) => {
                this.SessionService.updateAccounts(user as unknown as UserDTO);
                this.router.navigate(["accounts", "list"]);
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error retrieving user",
                );
              },
            );

          this.NotificationService.openSuccessSnackBar(
            "Account updated successfully",
          );
        },
        () => {
          this.NotificationService.openErrorSnackBar("Error updating account");
        },
      );
  }

  editCatalog() {
    this.router.navigate(["catalog"], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  removeGroup(selectedGroup: any) {
    this.accountUserForm.controls.groups.setValue(
      this.accountUserForm.controls.groups.value.filter(
        (group: number) => group !== selectedGroup.id,
      ),
    );
  }

  applyFilter() {
    if (this.hasSearchValue) {
      this.filteredUsers = this.unassignedUsers
        .filter((user) => {
          return (
            user.firstName.toLowerCase() +
            " " +
            user.lastName.toLowerCase()
          ).includes(this.searchValue!.toLowerCase());
        })
        .slice(0, 6);
    }
  }

  addNewCategory() {
    this.router.navigate(["categories", "create"], {
      relativeTo: this.activatedRoute,
    });
  }

  editCategory(category: any) {
    this.router.navigate(["categories", category.id], {
      relativeTo: this.activatedRoute,
    });
  }

  deleteCategory(category: any) {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this category ( ${category.name} )?`,
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res) => {
        if (res) {
          this.signalService
            .deleteSignalCategory(
              this.route.snapshot.params.accountID,
              category.id,
            )
            .pipe(
              tap(
                () => {
                  this.NotificationService.openSuccessSnackBar(
                    "Category deleted",
                  );
                },
                () => {
                  this.NotificationService.openErrorSnackBar(
                    "Error deleting category",
                  );
                },
              ),
              switchMap(() =>
                this.signalService.getSignalCategories(
                  this.route.snapshot.params.accountID,
                ),
              ),
            )
            .subscribe(
              (categories) => {
                this.initSignalCategories(categories as any);
                this.categoriesDataSource.sort = this.sort;
                this.categoriesDataSource.paginator = this.paginator;
              },
              () => {},
            );
        }
      });
  }

  onPageChange(e: PageEvent){
    this.localStorageSvc.pageSize = e.pageSize;
    this.perPage = e.pageSize;
  }
}

class UnassignedUser {
  expanded = false;
  constructor(private _userDTO: UserDTO) {}

  get id() {
    return this._userDTO.id;
  }

  get accountUsers() {
    return this._userDTO.accountUsers;
  }

  get firstName() {
    return this._userDTO.first_name;
  }

  get lastName() {
    return this._userDTO.last_name;
  }

  get email() {
    return this._userDTO.email;
  }

  get userDTO() {
    return this._userDTO;
  }
}
